var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03517 9.23621C6.40892 7.84154 7.84252 6.40795 9.23718 6.03419L17.9322 3.70403C19.3268 3.33027 20.1545 4.15788 19.7807 5.55255L17.4505 14.2475C17.0768 15.6422 15.6432 17.0758 14.2485 17.4496L5.55352 19.7797C4.15886 20.1535 3.33124 19.3259 3.705 17.9312L6.03517 9.23621Z",
    fill: "#9E77ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54982 5.75183C2.92357 4.35716 4.35716 2.92357 5.75183 2.54982L14.4468 0.219649C15.8415 -0.154108 16.6691 0.673505 16.2954 2.06817L13.9652 10.7632C13.5914 12.1578 12.1578 13.5914 10.7632 13.9652L2.06817 16.2953C0.673506 16.6691 -0.154107 15.8415 0.21965 14.4468L2.54982 5.75183Z",
    fill: "#6941C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany01);
export default __webpack_public_path__ + "static/media/company-01.8216bba4ab62be30fddf6075a5c2915d.svg";
export { ForwardRef as ReactComponent };